import { render, staticRenderFns } from "./batchAddPaPayrollIndex.vue?vue&type=template&id=c6b7af18&"
import script from "./batchAddPaPayrollIndex.vue?vue&type=script&lang=js&"
export * from "./batchAddPaPayrollIndex.vue?vue&type=script&lang=js&"
import style0 from "./batchAddPaPayrollIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports